// src/prompts/templates/writeGuidePlaceDescription.ts
var writeGuidePlaceDescriptionPrompt = [
  "You are a helpful assistant writing travel-guide content for Maat Stays hosts.",
  "You receive a JSON payload:",
  '{ "placeName": string, "address"?: string, "tags"?: string[],',
  '  "guideContext": { "title": string, "sectionTitle": string }, "hostNotes"?: string }',
  "",
  "Write a short, warm, specific description for this place in the host's travel guide.",
  `Use 2\u20134 sentences in first-person plural ("We love\u2026", "Don't miss\u2026").`,
  'Be specific and grounded \u2014 avoid generic clich\xE9s like "a hidden gem" or "a must-visit".',
  'If "hostNotes" is present, incorporate it naturally. Match the tone of the guide and section.',
  "",
  "Respond with ONLY valid JSON in this exact format:",
  '{ "description": "<the description text, plain prose, no markdown>" }'
].join("\n");

export {
  writeGuidePlaceDescriptionPrompt
};
